export default "__VITE_ASSET__BNvAy3YD__"